<template>
  <div class="season">
    <div class="s-title">
      <span class="zero">0</span><span class="one">1</span> СЕЗОН
    </div>
    <div class="s-date">26.04.2026</div>
  </div>
</template>

<style lang="scss">
.season {
  background: url(/assets/background.png);

  box-sizing: border-box;

  width: 469px;
  height: 182px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding-left: 25px;

  .s-title {
    font-family: "Manrope";
    font-size: 48px;
    font-weight: 800;
    color: white;

    .zero {
      color: #775154;
    }

    .one {
      color: #ffb3bb;
    }
  }

  .s-date {
    margin-top: 24px;
    font-family: "Manrope";
    font-size: 20px;
    font-weight: 600;
    color: #929292;
  }
}
</style>

<script>
export default {
  name: "Season",
};
</script>
